/* eslint-disable no-unused-vars */
import React, { useState } from 'react'
// import axios from 'axios'
import moment from 'moment'
import './index.scss'
import { makeStyles } from '@material-ui/core/styles'
import InputLabel from '@material-ui/core/InputLabel'
import MenuItem from '@material-ui/core/MenuItem'
import FormControl from '@material-ui/core/FormControl'
import Select from '@material-ui/core/Select'
import TextField from '@material-ui/core/TextField'
import ClearIcon from '@material-ui/icons/Clear'
import Chip from '@material-ui/core/Chip'
import Input from '@material-ui/core/Input'

const ITEM_HEIGHT = 48
const ITEM_PADDING_TOP = 8
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
}

const useStyles = makeStyles(theme => ({
    formControl: {
        // margin: theme.spacing(1),
        minWidth: 200,
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
    textfield: {
        '& > *': {
            margin: theme.spacing(1),
            width: '25ch',
        },
    },
    datetime: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        // width: 200,
    },
    multiSelect: {
        margin: theme.spacing(1),
        minWidth: 120,
        maxWidth: 300,
    },
    chips: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    chip: {
        margin: 2,
    },
    noLabel: {
        marginTop: theme.spacing(3),
    },
    a: {
        padding: 50,
    },
}))

// function getStyles(name, personName, theme) {
//     return {
//         fontWeight:
//             personName.indexOf(name) === -1
//                 ? theme.typography.fontWeightRegular
//                 : theme.typography.fontWeightMedium,
//     }
// }

const EntityEditor = props => {
    const classes = useStyles()
    const [entities, setEntities] = useState(
        props.intentEntityConfig.intent_entity_map[props.intent]
    )
    const [entityFills, setEntityFills] = useState(
        props.intentEntityConfig.entity_fills
    )
    const [showEntitySelector, setShowEntitySelector] = useState(false)
    const [selectedEntities, setSelectedEntities] = useState(
        props.selectedEntities.map(i => i.entity) || []
    )

    const addSelectedEntity = event => {
        const updatedEntities = [...selectedEntities, event.target.value]
        setSelectedEntities(updatedEntities)
        setShowEntitySelector(false)

        const updatedState = { ...props.selectedIntents }
        const newEntity = {
            entity: event.target.value,
            value: '',
            actual: '',
            confidence: 1,
            is_remerger: true,
        }
        updatedState[props.intent] = [...updatedState[props.intent], newEntity]
        props.requestDataHandler(updatedState)
    }

    const removeSelectedEntity = index => {
        const updatedEntities = selectedEntities.filter(
            (item, i) => i !== index
        )
        setSelectedEntities(updatedEntities)

        const updatedState = { ...props.selectedIntents }
        updatedState[props.intent] = updatedState[props.intent].filter(
            (item, i) => i !== index
        )
        props.requestDataHandler(updatedState)
    }

    const handleInputChange = (event, index) => {
        const updatedState = { ...props.selectedIntents }
        updatedState[props.intent][index].value = event.target.value
        updatedState[props.intent][index].actual = event.target.value
        updatedState[props.intent][index].confidence = 1
        updatedState[props.intent][index].is_remerger = true
        props.requestDataHandler(updatedState)
    }

    const getBasicInput = (entity, index) => (
        <TextField
            className={classes.formControl}
            id='standard-basic'
            label={entity}
            multiline
            value={props.selectedIntents[props.intent][index].value}
            onChange={event => handleInputChange(event, index)}
        />
    )

    const getMultiChoiceInput = (entity, index, data) => (
        <FormControl className={classes.multiSelect}>
            <InputLabel id='demo-mutiple-chip-label'>{entity}</InputLabel>
            <Select
                labelId='demo-mutiple-chip-label'
                id='demo-mutiple-chip'
                multiple
                MenuProps={MenuProps}
                value={props.selectedIntents[props.intent][index].value || []}
                onChange={event => handleInputChange(event, index)}
                input={<Input id='select-multiple-chip' />}
                renderValue={selected => (
                    <div className={classes.chips}>
                        {selected.map((value, i) => (
                            <Chip
                                key={value + 'chip' + i}
                                label={value}
                                className={classes.chip}
                            />
                        ))}
                    </div>
                )}
            >
                {data.map((item, i) => (
                    <MenuItem key={item + 'chip-item' + i} value={item}>
                        {item}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    )

    const getDatetimeInput = (entity, index) => {
        // useEffect(() => {
        // console.log('time')
        // }, [])
        console.log(
            'Default value!',
            props.selectedIntents[props.intent][index].value
        )
        const date = new Date()
        return (
            <TextField
                id='datetime-local'
                label={entity}
                type='datetime-local'
                defaultValue={
                    props.selectedIntents[props.intent][index].value
                        ? props.selectedIntents[props.intent][
                            index
                        ].value.substr(0, 16)
                        : moment().format('YYYY-MM-DDTHH:mm')
                }
                className={classes.datetime}
                InputLabelProps={{
                    shrink: true,
                }}
                onChange={event => handleInputChange(event, index)}
            />
        )
    }

    const getDropdownInput = (entity, index, data) => (
        <FormControl className={classes.formControl}>
            <InputLabel id='demo-simple-select-label'>{entity}</InputLabel>
            <Select
                labelId='demo-simple-select-label'
                id='demo-simple-select'
                value={props.selectedIntents[props.intent][index].value}
                onChange={event => handleInputChange(event, index)}
            >
                {data.map((item, i) => (
                    <MenuItem key={item + 'entity-dropdown' + i} value={item}>
                        {item}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    )

    const getInputType = (entity, index) => {
        let elem = getBasicInput(entity, index)

        const inputSettings = entityFills[entity]
        if (!inputSettings) return elem

        const { inputType, data } = inputSettings

        switch (inputType) {
            case 'multi_choice':
                elem = getMultiChoiceInput(entity, index, data)
                break
            case 'datetime':
                elem = getDatetimeInput(entity, index)
                break
            case 'text':
                break
            case 'dropdown':
                elem = getDropdownInput(entity, index, data)
                break
            default:
                break
        }

        return elem
    }

    return (
        <div className='EntityEditor__container' key={props.intent}>
            <p>{props.intent}</p>
            {selectedEntities.map((item, i) => (
                <div
                    key={props.intent + item + 'list' + i}
                    className='EntityEditor__entity'
                >
                    {getInputType(item, i)}
                    <ClearIcon
                        size='small'
                        style={{ cursor: 'pointer' }}
                        onClick={() => removeSelectedEntity(i)}
                    />
                </div>
            ))}
            {entities && entities.length > 0 ? (
                <div
                    className={
                        !showEntitySelector
                            ? 'EntityEditor__button-container-show'
                            : 'EntityEditor__button-container-hide'
                    }
                >
                    <div
                        className='EntityEditor__button'
                        onClick={() => setShowEntitySelector(true)}
                    >
                        <p>add entity</p>
                    </div>
                </div>
            ) : (
                <div
                    className={
                        !showEntitySelector
                            ? 'EntityEditor__button-container-show'
                            : 'EntityEditor__button-container-hide'
                    }
                >
                    <div className='EntityEditor__button-disabled'>
                        <p>no entities</p>
                    </div>
                </div>
            )}
            <div
                className={
                    showEntitySelector
                        ? 'EntityEditor__select-show'
                        : 'EntityEditor__select-hide'
                }
            >
                <FormControl className={classes.formControl}>
                    <InputLabel id='demo-simple-select-label'>
                        Add entity
                    </InputLabel>
                    <Select
                        labelId='demo-simple-select-label'
                        id='demo-simple-select'
                        value='Entities'
                        onChange={addSelectedEntity}
                    >
                        {entities && entities.map((item, i) => (
                            <MenuItem
                                key={props.intent + item + 'select' + i}
                                value={item}
                            >
                                {item}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
                <div className='EntityEditor__button-container-show'>
                    <div
                        className='EntityEditor__button'
                        onClick={() => setShowEntitySelector(false)}
                    >
                        <p>cancel</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default EntityEditor
